<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myapplication.missing_document.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title') }} > </span>
            <span class="back_loc">{{ $t('myapplication.missing_document.title') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.voluntaryamendment.fields.step_01')  }}</h2>
              <p>{{ $t('modification.voluntaryamendment.fields.enter_details')  }}</p>
            </v-flex>
            <v-flex class="active step_box step02">
              <h2>{{ $t('modification.voluntaryamendment.fields.step_02')  }}</h2>
              <p>{{ $t('modification.voluntaryamendment.fields.review_submit')  }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                class="my_app_tabs_data type2"
                hide-slider
                grow
                v-model="activeTab"
              >
                <v-tab class="mw-200" href="#tab-1">{{ $t('myrequest.list.fields.request_data') }}</v-tab>
                <v-tab class="mw-200" href="#tab-2">{{ $t('modification.voluntaryamendment.fields.attached_documents')  }}</v-tab>


                <v-tab-item value="tab-1">
                  <ApplicationInformation
                    :receipt_no.sync = receipt_no
                  />
                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          min-width="150"
                          min-height="50"
                          dark
                          class="btn-normal br_none"
                          @click.stop="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>
                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.request_content_confirm === 'N'"
                          @click.stop="fnConfirmContent('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.request_content_confirm === 'Y'"
                          @click.stop="fnConfirmContent('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>
                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="nextDisabledYn"
                          @click="fnSubmit()"
                        ><v-icon small>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item value="tab-2">
                  <DocumentViewer
                    :items="documentFileList"
                  />
                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          min-width="150"
                          min-height="50"
                          dark
                          class="btn-normal br_none"
                          @click.stop="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>
                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.ind_attached_confirm === 'N'"
                          @click.stop="fnConfirmAttacheddoc('Y')"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="confirm.ind_attached_confirm === 'Y'"
                          @click.stop="fnConfirmAttacheddoc('N')"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>
                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="nextDisabledYn"
                          @click="fnSubmit()"
                        ><v-icon small>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>
                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ApplicationInformation from '@/components/layout/ApplicationInformation'
import DocumentViewer from '@/components/layout/DocumentViewer'

export default {
  components :{
    ApplicationInformation,
    DocumentViewer
  },
  data () {
    return {
      receipt_no : this.$route.params.receipt_no,
      activeTab : 'tab-1',
      documentFileList: [],
      confirm : {
        request_content_confirm: '',
        ind_attached_confirm  : ''
      },
    }
  },
  computed : {
    nextDisabledYn (){
      return (
          this.confirm.request_content_confirm === 'N' ||
          this.confirm.ind_attached_confirm === 'N'
          )
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetDocumentFileList()
    this.fnGetIndConfirmList()

    // 푸터 여백 처리
    document.querySelectorAll('.copyright_wrap')[0].classList.add('mb-45')
  },
  methods: {
    fnGetIndConfirmList(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.confirm.ind_attached_confirm  = res.data.ind_attached_confirm
            this.confirm.request_content_confirm = res.data.request_content_confirm

            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6405'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetIndConfirmList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetBeforeApplicantList(){
      requestApi({
        url: '/receivings/amendment/' + this.receipt_no + '/applicants/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.beforeApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBeforeApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoBefore(){
      this.$router.push({path:'/myapplication/submitmissingdocument/step1/' + this.receipt_no})
    },
    fnConfirmContent(confirmVal){
      let params = {
        request_content_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.request_content_confirm = confirmVal

            //다음탭으로 넘김
            if(confirmVal === 'Y'){
              this.activeTab = 'tab-2'
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmAttacheddoc(confirmVal){
      let params = {
        ind_attached_confirm : confirmVal
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.fnGetMessage(confirmVal)
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.confirm.ind_attached_confirm = confirmVal
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmAttacheddoc(confirmVal)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnSubmit(){
      requestApi({
        url: '/receivings/missing/document/'+this.receipt_no+'/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {

            let option = {
              text : this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)

            this.$router.push('/myrequest/list')
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnIsNotNull(value){
      return !utils.isNull(value)
    },
    getExtIcon(fileName){
      let fileNameArray = fileName.split(".")
      let ext = fileNameArray[fileNameArray.length - 1].toLowerCase()

      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      }else{
        return 'mdi-paperclip'
      }
    },

    fnGetMessage(val){
      return val == 'Y' ? this.$t('common.message.confirm.success') : this.$t('common.message.cancel_confirm.success')
    },
  }
}
</script>